export enum PaintCodeType {
  BasicOrUni = 'basic_or_uni',
  Metallic = 'metallic',
  Mica = 'mica',
  Pearl = 'pearl',
  Unknown = 'unknown'
}
